import { useTranslation } from 'react-i18next';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui';
import type { ListMerchantsParams } from '@/types/merchant';

interface MerchantFiltersProps {
  filters: ListMerchantsParams;
  onFiltersChange: (filters: ListMerchantsParams) => void;
}

export function MerchantFilters({ filters, onFiltersChange }: MerchantFiltersProps) {
  const { t } = useTranslation('merchants');

  const handleStatusChange = (value: string) => {
    onFiltersChange({
      ...filters,
      status: value === 'all' ? undefined : (value as 'active' | 'suspended' | 'deactivated'),
      cursor: undefined,
    });
  };

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <Select value={filters.status ?? 'all'} onValueChange={handleStatusChange}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder={t('list.filters.status')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">{t('list.filters.allStatuses')}</SelectItem>
          <SelectItem value="active">{t('list.filters.active')}</SelectItem>
          <SelectItem value="suspended">{t('list.filters.suspended')}</SelectItem>
          <SelectItem value="deactivated">{t('list.filters.deactivated')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
